import { render } from "./PhilateliePage.vue?vue&type=template&id=9cd328c4"
import script from "./PhilateliePage.vue?vue&type=script&lang=js"
export * from "./PhilateliePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__